import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Route guard that checks feature access
 * Redirects to home if feature is not allowed
 */
function FeatureRoute({ allowed, children }) {
  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default FeatureRoute;
